export const isLoggedIn = () => localStorage.getItem('@efw/user') !== null;